import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-expanded-map-dialog',
  templateUrl: './expanded-map-dialog.component.html',
  styleUrls: ['./expanded-map-dialog.component.scss']
})
export class ExpandedMapDialogComponent implements OnInit {

  public readonly title: string;
  public readonly mapPath: string;

  constructor(public dialogRef: MatDialogRef<ExpandedMapDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.mapPath = data.mapPath; // 'https://wittlock.github.io/ngx-image-zoom/assets/fullres.jpg'; //
    this.title = data.title;
  }

  ngOnInit(): void {
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
